
import panelStyle from './panel.module.scss';

import icn_copper from "assets/images/icons/icn_copper_disconnected.svg";
import icn_fiber from "assets/images/icons/icn_fiber_black.svg";
import icn_copper_10_100mbps from "assets/images/icons/icn_copper_10_100mbps.svg";
import icn_copper_1g from "assets/images/icons/icn_copper_1gbps.svg";
import icn_copper_25_5g from "assets/images/icons/icn_copper_25_5g.svg";
import icn_copper_10g from "assets/images/icons/icn_copper_10g.svg";
import icn_copper_25g from "assets/images/icons/icn_copper_25g.svg";
import icn_copper_40g from "assets/images/icons/icn_copper_40g.svg";
import icn_copper_100g from "assets/images/icons/icn_copper_100g.svg";
import icn_copper_disconnected from "assets/images/icons/icn_copper_disconnected-2.svg";
import icn_copper_disabled from "assets/images/icons/icn_copper_disabled.svg";
import icn_copper_error from "assets/images/icons/icn_copper_error.svg";
// import icn_fiber_1g from "assets/images/icons/icn_fiber_1g.svg";
// import icn_fiber_25_5g from "assets/images/icons/icn_fiber_5g.svg";
// import icn_fiber_10g from "assets/images/icons/icn_fiber_10g.svg";
// import icn_fiber_25g from "assets/images/icons/icn_fiber_25g.svg";
// import icn_fiber_40g from "assets/images/icons/icn_fiber_40g.svg";
// import icn_fiber_100g from "assets/images/icons/icn_fiber_100g.svg";
// import icn_fiber_disconnected from "assets/images/icons/icn_fiber_disconnected.svg";
// import icn_fiber_disabled from "assets/images/icons/icn_fiber_disabled.svg";
// import icn_fiber_error from "assets/images/icons/icn_fiber_error.svg";
import icn_port_blocking from "assets/images/icons/icn_port_Blocking_Dark.svg";
import icn_port_uplink from "assets/images/icons/icn_port_uplink_Dark.svg";
import icn_port_mirror from "assets/images/icons/icn_port_mirror_Dark.svg";
import icn_port_aggregating from "assets/images/icons/icn_port_aggregating_Dark.svg";
import icn_port_poe_30w from "assets/images/icons/icn_port_poe_Dark.svg";
import icn_port_poe_60w from "assets/images/icons/icn_port_poe++_Dark.svg";
import icn_port_poe_90w from "assets/images/icons/icn_port_poe+++_Dark.svg";

import React from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import { cloneDeep } from "lodash";
import { blockStyle, numberStyle, parentStyle } from './const';

/***
 *  ##### Port definition #####
 *  @portStaIndex
 *  The number of port(1...n)
 * 
 *  @portAttriAdminState
 *  1: Enabled
 *  2: Disabled
 * 
 *  @portStaStatus
 *  1: Link up
 *  2: Link down
 * 
 *  @portStaIsUplink
 *  0: Not uplink
 *  1: Uplink
 * 
 *  @portStaSpeed
 *  1:  Auto
 *  2:  10M
 *  3:  100M
 *  4:  1000M
 *  5:  1000M-Master
 *  6:  1000M-Slave
 *  7:  2500M
 *  8:  5000M
 *  9:  10G
 *  10: 25G
 *  11: 40G
 *  12: 100G
 *
 *  @portStaMediaType
 *  1: RJ45
 *  2: Fiber
 *
 *  @portStaDuplex
 *  1: Auto
 *  2: Full
 *  3: Half
 *
 *  @portStaErrorState
 *  00: Normal
 *  04: Error Disabled(Loop Detected)
 *  08: STP Discarding(STP Discarding)
 *  10: Authentication fail(802.1x Authentication Failed 	)
 *  20: LACP Abnormal(LACP Abnormal)
 *  40: Poe Overload(PoE Port Overloaded)
 *  80: PoE Denied(PoE System Overload Denied)
 *
 *  @poePortStatus
 *  0:  Disabled
 *  1:  Searching
 *  2:  Requesting
 *  3:  Delivering
 *  4:  MPS Absent
 *  5:  PD Short
 *  6:  Overload
 *  7:  Power Denied
 *  8:  Thermal Shutdown
 *  9:  Startup Failure
 *  10: Classification Failure
 *
 *  @poePortClassifications
 *  0:   30w
 *  1:   30w
 *  2:   30w
 *  3:   30w
 *  4:   30w
 *  5:   60w
 *  6:   60w
 *  7:   90w
 *  8:   90w
 *  255: Unclassified
 */

const defaultPort = {
  adminState: 1,
  status: 2,
  isUplink: 0,
  speed: 1,
  duplex: 1,
  errorState: "00",
  poe: {
    status: 0,
    classifications: null,
    power: 0, // Float W
  },
  traffic: {
    sent: 0, // Byte
    received: 0 // Byte
  }
}

/***
 *  #### Port type definition #####
 */
const portTypeOptions = [
  1, // Copper,Twister
  2, // SFP, SFP+,SFP++
  3, // Combo SFP & Copper/Twister, Copper draw first
  4, // Combo SFP & Copper/Twister, SFP draw first
];

/***
 *  #### Error Message definition #####
 */
const errorMessage = {
  '04': 'Loop Detected',
  '08': 'STP Discarding',
  '10': '802.1x Authentication Failed',
  '20': 'LACP Abnormal',
  '40': 'PoE Port Overloaded',
  '80': 'PoE System Overload Denied',
}

class SwitchDevice {
  constructor(name = "", model = "", linkStatus = false, portTypes = [], portStatuses = []) {
    if (SwitchDevice.instance) {
      return SwitchDevice.instance;
    }

    this.name = name;
    this.model = model;
    this.linkStatus = linkStatus;
    this.portTypes = portTypes;
    this.portStatuses = portStatuses.map(port => ({
      index: port.portStaIndex - 1,
      adminState: port.portAttriAdminState,
      status: port.portStaStatus,
      isUplink: port.portStaIsUplink,
      speed: port.portStaSpeed,
      mediaType: port.portStaMediaType,
      duplex: port.portStaDuplex,
      errorState: port.portStaErrorState,
      poe: {
        status: port.poePortStatus,
        classifications: port.poePortClassifications,
        power: port.poePortPower,
      },
      traffic: {
        sent: port.txStats,
        received: port.rxStats,
      }
    }));
  }

  makePanel() {
    const originPanelArray = [];
    const panelArray = [];
    const portLength = this.portTypes.length;
    const hasBottomPanel = portLength > 12;
    const halfPortLength = Math.ceil(portLength / 2);
    const comboPorts = [];

    if (hasBottomPanel) {
      // Bottom row
      for (let i = 0; i < this.portTypes.length; i = i + 2) {
        const originPortTypeNumber = this.portTypes[i];
        let portTypeNumber = portTypeOptions[0];

        if (this.portTypes[i] === portTypeOptions[1]) portTypeNumber = portTypeOptions[1];
        if (this.portTypes[i] === portTypeOptions[2]) {
          portTypeNumber = portTypeOptions[0];
          comboPorts.push({ portNumberIndex: i + 1, portType: this.portTypes[i] });
        }
        if (this.portTypes[i] === portTypeOptions[3]) {
          portTypeNumber = portTypeOptions[1];
          comboPorts.push({ portNumberIndex: i + 1, portType: this.portTypes[i] });
        }

        originPanelArray.push({
          portNumberIndex: i,
          portType: portTypeNumber,
          originPortType: originPortTypeNumber,
        });
      }

      // Top row
      for (let i = 1; i < this.portTypes.length; i = i + 2) {
        const originPortTypeNumber = this.portTypes[i];
        let portTypeNumber = portTypeOptions[0];

        if (this.portTypes[i] === portTypeOptions[1]) portTypeNumber = portTypeOptions[1];
        if (this.portTypes[i] === portTypeOptions[2]) {
          portTypeNumber = portTypeOptions[0];
          comboPorts.push({ portNumberIndex: i + 1, portType: this.portTypes[i] });
        }
        if (this.portTypes[i] === portTypeOptions[3]) {
          portTypeNumber = portTypeOptions[1];
          comboPorts.push({ portNumberIndex: i + 1, portType: this.portTypes[i] });
        }

        originPanelArray.push({
          portNumberIndex: i,
          portType: portTypeNumber,
          originPortType: originPortTypeNumber,
        });
      }
    } else {
      for (let i = 0; i < this.portTypes.length; i++) {
        const originPortTypeNumber = this.portTypes[i];
        let portTypeNumber = portTypeOptions[0];

        if (this.portTypes[i] === portTypeOptions[1]) portTypeNumber = portTypeOptions[1];
        if (this.portTypes[i] === portTypeOptions[2]) {
          portTypeNumber = portTypeOptions[0];
          comboPorts.push({ portNumberIndex: i + 1, portType: this.portTypes[i] });
        }
        if (this.portTypes[i] === portTypeOptions[3]) {
          portTypeNumber = portTypeOptions[1];
          comboPorts.push({ portNumberIndex: i + 1, portType: this.portTypes[i] });
        }

        originPanelArray.push({
          portNumberIndex: i,
          portType: portTypeNumber,
          originPortType: originPortTypeNumber,
        });
      }
    }

    // Split into top & bottom panels
    if (hasBottomPanel) {
      const topPanel = originPanelArray.slice(0, halfPortLength);
      const bottomPanel = originPanelArray.slice(halfPortLength, portLength);
      panelArray.push(topPanel, bottomPanel);
    } else {
      panelArray.push(originPanelArray);
    }

    // Add combo ports to each panel
    for (let i = 0; i < panelArray.length; i++) {
      const comboPortsInPanel = cloneDeep(
        panelArray[i].filter((port) => {
          return (
            port.originPortType === portTypeOptions[2] ||
            port.originPortType === portTypeOptions[3]
          );
        })
      );

      for (let j = 0; j < comboPortsInPanel.length; j++) {
        comboPortsInPanel[j].portType = comboPortsInPanel[j].originPortType;
      }

      const newPanel = [...panelArray[i], ...comboPortsInPanel];
      panelArray[i] = [...newPanel];
    }

    return [
      ...panelArray
    ]
  }

  get panel() {
    const panel = this.makePanel();
    return new PortPanel(this.linkStatus, panel, this.portStatuses);
  }
}

class PortPanel {
  constructor(linkStatus, panel, portStatuses = []) {
    this.linkStatus = linkStatus;
    this.panel = panel;
    this.portStatuses = portStatuses;
  }

  getPortStatusByIndex(port) {
    let portNumberIndex = port.portNumberIndex;
    let mediaType = 1; // Default to Copper
    if (
      (port.portType === 2 && port.portType === port.originPortType)
      || ([3, 4].includes(port.portType) && port.portType === port.originPortType)
    ) {
      mediaType = 2;
    }

    return this.portStatuses.find(p => p.index === portNumberIndex && p.mediaType === mediaType) || {
      ...defaultPort,
      index: portNumberIndex,
      mediaType: mediaType,
    };
  }

  render() {
    return (
      <Box className={panelStyle['container']}>
        <Box id="port-status-inner" className={panelStyle['inner-container']}>
          {
            this.panel.map((panel, panelIndex) => (
              <Box key={panelIndex} className={panelIndex === 0 ? panelStyle['upper'] : panelStyle['lower']} >
                {
                  panel.map((port) => (
                    <>
                      {new Port(panel, port, panelIndex === 0).render(this.linkStatus, this.getPortStatusByIndex(port))}
                    </>
                  ))
                }
              </Box>
            ))}
        </Box>
        <Box className={panelStyle['divider']} />
        <Box id="port-status-footer" className={panelStyle['footer']} style={{ display: 'none' }}>
          <Box className={panelStyle['item']}>
            <img className={panelStyle['img']} src={icn_copper} alt="" />
            <Typography className={panelStyle['text']}>Copper</Typography>
          </Box>
          <Box className={panelStyle['item']}>
            <img className={panelStyle['img']} src={icn_fiber} alt="" />
            <Typography className={panelStyle['text']}>Fiber</Typography>
          </Box>
          <Box className={panelStyle['item']}>
            <img className={panelStyle['img']} src={icn_copper_100g} alt="" />
            <Typography className={panelStyle['text']}>100 Gbps</Typography>
          </Box>
          <Box className={panelStyle['item']}>
            <img className={panelStyle['img']} src={icn_copper_40g} alt="" />
            <Typography className={panelStyle['text']}>40 Gbps</Typography>
          </Box>
          <Box className={panelStyle['item']}>
            <img className={panelStyle['img']} src={icn_copper_25g} alt="" />
            <Typography className={panelStyle['text']}>25 Gbps</Typography>
          </Box>
          <Box className={panelStyle['item']}>
            <img className={panelStyle['img']} src={icn_copper_10g} alt="" />
            <Typography className={panelStyle['text']}>10 Gbps</Typography>
          </Box>
          <Box className={panelStyle['item']}>
            <img className={panelStyle['img']} src={icn_copper_25_5g} alt="" />
            <Typography className={panelStyle['text']}>2.5/5 Gbps</Typography>
          </Box>
          <Box className={panelStyle['item']}>
            <img className={panelStyle['img']} src={icn_copper_1g} alt="" />
            <Typography className={panelStyle['text']}>1 Gbps</Typography>
          </Box>
          <Box className={panelStyle['item']}>
            <img className={panelStyle['img']} src={icn_copper_10_100mbps} alt="" />
            <Typography className={panelStyle['text']}>10/100 Mbps</Typography>
          </Box>
          <Box className={panelStyle['item']}>
            <img className={panelStyle['img']} src={icn_copper_disabled} alt="" />
            <Typography className={panelStyle['text']}>Disabled</Typography>
          </Box>
          <Box className={panelStyle['item']}>
            <img className={panelStyle['img']} src={icn_copper_disconnected} alt="" />
            <Typography className={panelStyle['text']}>Disconnected</Typography>
          </Box>
          <Box className={panelStyle['item']}>
            <img className={panelStyle['img']} src={icn_copper_error} alt="" />
            <Typography className={panelStyle['text']}>Error</Typography>
          </Box>
          {/* <Box className={panelStyle['item']}>
            <img className={panelStyle['img']} src={icn_port_blocking} alt="" />
            <Typography className={panelStyle['text']}>Blocking</Typography>
          </Box> */}
          {/* <Box className={panelStyle['item']}>
            <img className={panelStyle['img']} src={icn_port_uplink} alt="" />
            <Typography className={panelStyle['text']}>Uplink</Typography>
          </Box> */}
          {/* <Box className={panelStyle['item']}>
            <img className={panelStyle['img']} src={icn_port_mirror} alt="" />
            <Typography className={panelStyle['text']}>Mirror</Typography>
          </Box> */}
          {/* <Box className={panelStyle['item']}>
            <img className={panelStyle['img']} src={icn_port_aggregating} alt="" />
            <Typography className={panelStyle['text']}>Aggregating</Typography>
          </Box> */}
          <Box className={panelStyle['item']}>
            <img className={panelStyle['img']} src={icn_port_poe_30w} alt="" />
            <Typography className={panelStyle['text']}>PoE/PoE+</Typography>
          </Box>
          <Box className={panelStyle['item']}>
            <img className={panelStyle['img']} src={icn_port_poe_60w} alt="" />
            <Typography className={panelStyle['text']}>PoE++ (60W)</Typography>
          </Box>
          <Box className={panelStyle['item']}>
            <img className={panelStyle['img']} src={icn_port_poe_90w} alt="" />
            <Typography className={panelStyle['text']}>PoE++ (90W)</Typography>
          </Box>
        </Box>
      </Box>
    )
  }
}

class Port {
  constructor(panel, port, isTopPanel = true) {
    this.panel = panel;
    this.port = port;
    this.isTopPanel = isTopPanel;
  }

  render(linkStatus, status) {
    const { portNumberIndex, portType, originPortType } = this.port;
    const isComboPort = (portType === 3 || portType === 4) && (portType === originPortType);
    const comboPortNumber = this.panel.filter(port => port.portType === 3 || port.portType === 4).length;
    const portStatus = new PortStatus(linkStatus, status);

    const tooltip = {
      port: portNumberIndex + 1,
      speed: '',
      sent: '-',
      received: '-',
      poe: '-',
      isError: false,
    }

    let spaceStyle = {};
    if (isComboPort && comboPortNumber > 1) {
      spaceStyle = panelStyle["space"];
    } else if (isComboPort && comboPortNumber === 1) {
      spaceStyle = panelStyle["space-once"];
    }

    if (portStatus.connected) {
      tooltip.sent = portStatus.traffic.sent;
      tooltip.received = portStatus.traffic.received;
    }

    if (
      portStatus.connected
      && portStatus.poe.enable
    ) {
      tooltip.poe = `${portStatus.poe.power} W`;
    }

    let isOnlinePort = false;
    let layer1 = panelStyle["copper_disconnected"];
    if (portStatus.copper) {
      if (portStatus.error) {
        tooltip.isError = true;
        tooltip.speed = 'Error';
        layer1 = panelStyle["copper_error"];
      } else if (portStatus.disabled) {
        tooltip.speed = 'Disabled';
        layer1 = panelStyle["copper_disabled"];
      } else if (portStatus.connected) {
        isOnlinePort = true;
        if (portStatus['speed']['100g']) {
          tooltip.speed = '100 Gbps';
          layer1 = panelStyle["copper_100g"];
        } else if (portStatus['speed']['40g']) {
          tooltip.speed = '40 Gbps';
          layer1 = panelStyle["copper_40g"];
        } else if (portStatus['speed']['25g']) {
          tooltip.speed = '25 Gbps';
          layer1 = panelStyle["copper_25g"];
        } else if (portStatus['speed']['10g']) {
          tooltip.speed = '10 Gbps';
          layer1 = panelStyle["copper_10g"];
        } else if (portStatus['speed']['2.5g']) {
          tooltip.speed = '2.5/5 Gbps';
          layer1 = panelStyle["copper_25_5g"];
        } else if (portStatus['speed']['1g']) {
          tooltip.speed = '1 Gbps';
          layer1 = panelStyle["copper_1g"];
        } else if (portStatus['speed']['under1G']) {
          tooltip.speed = '10/100 Mbps';
          layer1 = panelStyle["copper_10_100m"];
        } else {
          layer1 = panelStyle["copper_disconnected"];
        }
      } else {
        tooltip.speed = 'Disconnected';
        layer1 = panelStyle["copper_disconnected"];
      }
    }

    if (portStatus.fiber) {
      if (portStatus.error) {
        tooltip.isError = true;
        tooltip.speed = 'Error';
        layer1 = panelStyle["fiber_error"];
      } else if (portStatus.disabled) {
        tooltip.speed = 'Disabled';
        layer1 = panelStyle["fiber_disabled"];
      } else if (portStatus.connected) {
        isOnlinePort = true;
        if (portStatus['speed']['100g']) {
          tooltip.speed = '100 Gbps';
          layer1 = panelStyle["fiber_100g"];
        } else if (portStatus['speed']['40g']) {
          tooltip.speed = '40 Gbps';
          layer1 = panelStyle["fiber_40g"];
        } else if (portStatus['speed']['25g']) {
          tooltip.speed = '25 Gbps';
          layer1 = panelStyle["fiber_25g"];
        } else if (portStatus['speed']['10g']) {
          tooltip.speed = '10 Gbps';
          layer1 = panelStyle["fiber_10g"];
        } else if (portStatus['speed']['2.5g']) {
          tooltip.speed = '2.5/5 Gbps';
          layer1 = panelStyle["fiber_25_5g"];
        } else if (portStatus['speed']['1g']) {
          tooltip.speed = '1 Gbps';
          layer1 = panelStyle["fiber_1g"];
        } else {
          layer1 = panelStyle["fiber_disconnected"];
        }
      } else {
        tooltip.speed = 'Disconnected';
        layer1 = panelStyle["fiber_disconnected"];
      }
    }

    // let layer2 = null; // Blocking
    // let layer3 = null; // Uplink
    // let layer4 = null; // Mirror
    // let layer5 = null; // Aggregating
    let layer6 = null; // PoE 30W
    let layer7 = null; // PoE 60W
    let layer8 = null; // PoE 90W
    if (isOnlinePort) {
      // [TODO] Blocking
      // if (portStatus.blocking) {
      //   layer2 = panelStyle["blocking"];
      // }

      // if (portStatus.uplink) {
      //   layer3 = panelStyle["uplink"];
      // }

      // [TODO] Mirror
      // if (portStatus.mirror) {
      //   layer4 = panelStyle["mirror"];
      // }

      // [TODO] Aggregating
      // if (portStatus.aggregating) {
      //   layer5 = panelStyle["aggregating"];
      // }

      if (portStatus.poe.enable) {
        if (portStatus.poe["90w"]) {
          layer8 = panelStyle["poe-90w"];
        } else if (portStatus.poe["60w"]) {
          layer7 = panelStyle["poe-60w"];
        } else if (portStatus.poe["30w"]) {
          layer6 = panelStyle["poe-30w"];
        } else {
          layer6 = panelStyle["poe-30w"];
        }
      }
    }

    return (
      <Box className={`${panelStyle["port_wrapper"]} ${spaceStyle}`} key={portNumberIndex} style={blockStyle}>
        {this.isTopPanel && <div style={numberStyle}>{portNumberIndex + 1}</div>}
        <Tooltip
          arrow
          title={
            <Box className={panelStyle["tip-container"]}>
              <Box className={panelStyle["item"]}>
                <Box>Port</Box>
                <Box>{tooltip.port}</Box>
              </Box>
              <Box className={panelStyle["item"]}>
                <Box>Status</Box>
                <Box>{tooltip.speed}</Box>
              </Box>
              {
                tooltip.isError ? (
                  (
                    <b>
                      &lt;{errorMessage[status.errorState]}&gt;
                    </b>
                  )
                ) : (
                  <>
                    <Box className={panelStyle["item"]}>
                      <Box>Sent</Box>
                      <Box>{tooltip.sent}</Box>
                    </Box>
                    <Box className={panelStyle["item"]}>
                      <Box>Received</Box>
                      <Box>{tooltip.received}</Box>
                    </Box>
                    <Box className={panelStyle["item"]}>
                      <Box>PoE</Box>
                      <Box>{tooltip.poe}</Box>
                    </Box>
                  </>
                )
              }
            </Box>
          }>
          <Box className={panelStyle["port"]} style={parentStyle}>
            <Box className={layer1} />
            {/* {layer2 && <Box className={layer2} />}
            {layer3 && <Box className={layer3} />}
            {layer4 && <Box className={layer4} />}
            {layer5 && <Box className={layer5} />} */}
            {layer6 && <Box className={layer6} />}
            {layer7 && <Box className={layer7} />}
            {layer8 && <Box className={layer8} />}
          </Box>
        </Tooltip>
        {!this.isTopPanel && <Box style={{ ...numberStyle, paddingTop: '6px' }}>{portNumberIndex + 1}</Box>}
      </Box >
    );
  }
}

class PortStatus {
  constructor(linkStatus, portStatus) {
    this.linkStatus = linkStatus;
    this.status = portStatus;
  }

  get copper() {
    return this.status.mediaType === 1;
  }

  get fiber() {
    return this.status.mediaType === 2;
  }

  get connected() {
    return this.linkStatus && this.status.adminState === 1 && this.status.status === 1;
  }

  get disabled() {
    return this.status.adminState === 2;
  }

  get disconnected() {
    return this.status.adminState === 1 && this.status.status === 2;
  }

  get error() {
    return this.status.adminState === 1 && this.status.errorState !== "00";
  }

  // [TODO] blocking
  // [TODO] isMirror
  // [TODO] isAggregating

  get uplink() {
    return this.status.isUplink === 1;
  }

  get speed() {
    return {
      under1G: [1, 2, 3].includes(this.status.speed),
      "1g": [4, 5, 6].includes(this.status.speed),
      "2.5g": [7, 8].includes(this.status.speed),
      "10g": this.status.speed === 9,
      "25g": this.status.speed === 10,
      "40g": this.status.speed === 11,
      "100g": this.status.speed === 12,
    };
  }

  get poe() {
    let enabled = this.status.poe.status === 3; // Delivering
    let cls = this.status.poe.classifications ?? null;

    // Exclude less then 0 or greater than 8
    if (cls < 0 || cls > 8) {
      enabled = false
    }

    return {
      enable: enabled,
      "30w": enabled && (cls >= 0 && cls <= 4),
      "60w": enabled && (cls >= 5 && cls <= 6),
      "90w": enabled && (cls >= 7 && cls <= 8),
      "power": this.status.poe.power,
    };
  }

  get traffic() {
    return {
      sent: this._formatBytes(this.status.traffic.sent ?? 0, 0),
      received: this._formatBytes(this.status.traffic.received ?? 0, 0),
    };
  }

  _formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";

    const k = 1024;  // base unit
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const value = bytes / Math.pow(k, i);

    return value.toFixed(decimals) + " " + sizes[i];
  }
}

export default SwitchDevice;